export function getSessionStorageKey(consumerId: string): string {
    return `${consumerId}-loginservice-continuation`;
}
